import { useMemo, useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, useAction } from "convex/react";
//import { useQueries } from "convex-helpers/react";
//import { api } from "../../convex/_generated/api";
//import {api} from "./convex/_generated/api"
import {api} from "./convex/_generated/api"
//import Loader from "../components/Loader";


const CATEGORIES = [
  "Produce",
  "Dairy",
  "Meat",
  "Pantry",
  "Other",
  "Grains",
  "Spices",
  "Bread",
  "Legumes"
];


function daysUntil(date) {

  if (!date) return null;


  const [year, month, day] = date.split("-");


  const target = new Date(
    year,
    month - 1,
    day
  );


  const today = new Date();


  target.setHours(0,0,0,0);
  today.setHours(0,0,0,0);


  const diff =
    target.getTime() - today.getTime();


  return Math.round(
    diff / (1000 * 60 * 60 * 24)
  );

}



export default function PantryHome() {


  const { userId } = useParams();
  console.log(userId);



  const pantry = useQuery(
    api.pantry.getPantry,
    {
      userId
    }
  );



  const grocery = useQuery(
    api.grocery.getGroceryList,
    {
      userId
    }
  );



  

 const toggleUsed = useAction(
  api.pantry.toggleUsed
);

const toggleUseds = useAction(
  api.pantry.toggleUseds
);


  const [expiryDate,setExpiryDate] =
    useState({});


  const [category,setCategory] =
    useState({});
  
  
  const insertPantryHome = useMutation(
  api.pantry.insertPantryHome
);




  const pantryHome = useMemo(()=>{


    if(!pantry || !grocery)
      return [];


    const grocerySet =
      new Set(
        grocery.map(
          item=>item.ingredient
        )
      );


    return pantry.filter(
      item =>
        !grocerySet.has(
          item.ingredient
        )
    );


  },[
    pantry,
    grocery
  ]);

  const pantryHomenew = useQuery(
  api.pantryHome.getPantryHome,
  {
    userId
  }
);


useEffect(() => {

  if (!pantryHome.length || pantryHomenew === undefined)
    return;

  const existingIds = new Set(
    pantryHomenew.map(
      item => item.pantryHomeId
    )
  );


  pantryHome.forEach(item => {

    if (!existingIds.has(item._id)) {

      insertPantryHome({

        userId,

        pantryHomeId:item._id,

        ingredient:item.ingredient,

        category:item.category ?? "Other",

        expiryDate:item.expiryDate ?? undefined

      });

    }

  });


},[
  pantryHome,
  pantryHomenew,
  userId
]);


  const pantryHomeItems = pantryHomenew ?? [];


  
  const updatePantryHome = useMutation(
  api.pantryHome.updatePantryHome
);

  const recordWasteSaved = useMutation(
  api.wasteSavings.recordWasteSaved
);





  const useSoon = useMemo(()=>{


    return pantryHomeItems.filter(item=>{


      if(!item.expiryDate)
        return false;


      const days =
        daysUntil(
          item.expiryDate
        );


      return days >= 0 && days <= 3;


    });


  },[
    pantryHomeItems
  ]);







  const mealQueries = useMemo(()=>{


    const queries={};



    pantryHomeItems.forEach(item=>{


      queries[item.ingredient]={

        query:
          api.meals.getMealsByIngredient,


        args:{

          userId,

          ingredient:
            item.ingredient

        }

      };


    });



    return queries;


  },[
    pantryHomeItems,
    userId
  ]);





  //const mealsByIngredient =
    //useQueries(
      //mealQueries
    //);

  const ingredients = useMemo(()=>{

  return pantryHomeItems.map(
    item => item.ingredient
  );

},[pantryHomeItems]);



const rawMeals = useQuery(
  api.meals.getMealsByIngredients,
  {
    userId,
    ingredients
  }
);



const mealsByIngredient = useMemo(()=>{

  const grouped = {};

  (rawMeals ?? []).forEach(meal=>{

    meal.ingredients.forEach(item=>{

      const name = item.name;

      if(!grouped[name])
        grouped[name] = [];

      grouped[name].push(meal);

    });

  });


  return grouped;

},[
  rawMeals
]);





  const meals = useMemo(()=>{


    return Object.values(
      mealsByIngredient ?? {}
    )
    .flat()
    .filter(Boolean);



  },[
    mealsByIngredient
  ]);


    const pantryHomeCost = useMemo(()=>{

    return pantryHomeItems.reduce(
      (sum, item) => sum + (item.cost ?? 0),
      0
    );

  },[
    pantryHomeItems
  ]);


  const groceryCost = useMemo(()=>{

    return (grocery ?? []).reduce(
      (sum, item) => sum + (item.cost ?? 0),
      0
    );

  },[
    grocery
  ]);


  const savedAmounts = pantryHomeCost - groceryCost;







  //if(
    //pantry === undefined ||
    //grocery === undefined
  //){

    //return <Loader/>;

  //}







  return (

    <div className="screen">


      <div className="eyebrow">
        Pantry Home
      </div>



      <h1 className="page-title">
        What You Own
      </h1>



      <p className="subtitle">
        Ingredients available without shopping
      </p>







      {
        useSoon.length > 0 && (

          <div
            className="ticket"
            style={{
              borderColor:"var(--warn)"
            }}
          >

            <p
              style={{
                color:"var(--warn)"
              }}
            >
              USE SOON
            </p>



            {
              useSoon.map(item=>(

                <div
                  key={item._id}
                >

                  {item.ingredient}
                  {" expires "}
                  {item.expiryDate}

                </div>

              ))
            }


          </div>

        )
      }








      <h2 className="category-header">
        Pantry Items
      </h2>





      {
        pantryHomeItems.map(item=>(


          <div
            key={item._id}
            className="ticket"
            style={{ background: "white" }}
          >



            <div className="grocery-row">


              <span className="name">

                {item.ingredient}

              </span>


            </div>





            <div
              className="field"
            >

              <label>
                Category
              </label>


              <select

                value={
                  category[item._id] ??
                  item.category ??
                  "Other"
                }


                onChange={(e)=>{

                  setCategory(prev=>({

                    ...prev,

                    [item._id]:
                    e.target.value

                  }));

                }}

              >


                {
                  CATEGORIES.map(c=>(

                    <option
                      key={c}
                      value={c}
                    >
                      {c}
                    </option>

                  ))
                }


              </select>


            </div>






            <div
              className="field"
            >

              <label>
                Expiry date (optional)
              </label>


              <input

                type="date"


                value={

                  expiryDate[item._id] ??
                  item.expiryDate ??
                  ""

                }


                onChange={(e)=>{


                  setExpiryDate(prev=>({

                    ...prev,

                    [item._id]:
                    e.target.value

                  }));


                }}

              />


            </div>





            <button

              className="btn btn-primary btn-sm"


              onClick={()=>{


                updatePantryHome({

                  userId,

                  pantryHomeId:item._id,


                  category:

                    category[item._id] ??
                    item.category ??
                    "Other",


                  expiryDate:

                    expiryDate[item._id] ??
                    item.expiryDate


                });


              }}

            >

              Save

            </button>

            <button

                className="btn btn-secondary btn-sm"

                onClick={()=>{

                toggleUseds({
                      pantryHomeId: item._id,
                      userId: userId,
                    });

                }}

                >

                Mark Used

                </button>




          </div>


        ))
      }









      <h2
        className="category-header"
        style={{
          marginTop:30
        }}
      >
        Meals You Can Make
      </h2>





      {
        meals.length === 0 && (

          <div className="empty-state">

            <p>
              No meals available with your pantry.
            </p>

          </div>

        )
      }





      {
        meals.map(meal=>(


          <div
            key={meal._id}
            className="ticket"
          >

            <h3>
              {meal.mealName}
            </h3>


            <p>
              Day {meal.dayNumber}
            </p>


            <p>
              {meal.mealType}
            </p>



             <button
        className="btn btn-primary btn-sm"
              onClick={async()=>{

                await recordWasteSaved({

                  userId,

                  mealId: meal._id,

                  mealName:
                    meal.mealName,

                  ingredientsUsed: meal.ingredients.map(
                    item => item.name
                  ),

                  savedAmount:
                    //meal.estimatedCost // temporary estimate
                    savedAmounts

                });

              }}
            >

              Cooked This Meal

            </button>


          </div>


        ))
      }





    </div>

  );

}